export default __webpack_public_path__ + "static/media/tasks-line.d0f5fad3.svg";